import { FiFormEditLogicComponent } from './fi-form-edit-logic/fi-form-edit-logic.component';
import { FiFormEditFormComponent } from './fi-form-edit-form/fi-form-edit-form.component';
import { FiFormEditSettingsComponent } from './fi-form-edit-settings/fi-form-edit-settings.component';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { SideListOptionType } from '@fi-shared/types';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { cloneDeep, isDefined } from '@fi-shared/utils';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';
import { IFormEdit, IFormQuestion, IFormViewer } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { StatisticService } from '../../shared/statistic/statistic.service';
import { LoadingService } from '@fi-app/shared/fi-loading/loading.service';
import { NgModel } from '@angular/forms';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { BehaviorSubject } from 'rxjs';
import { FiFormSharedService } from '@fi-shared/fi-form-shared/fi-form-shared.service';
import { DetectDevicesService, FiSnackBarService } from '@fi-shared/fi-shared-services';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import {
    IContentLanguage,
    IContentLanguageLabelModel,
} from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiChoiceQuestionValidateComponent } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-choice-question/fi-choice-question-validate.component';

interface IFormPreviewData {
    formViewer: IFormViewer;
    isMobileView: boolean;
    selectedLanguageId: number;
    languageList: IContentLanguage[];
    onSave: () => void;
}

@Component({
    selector: 'fi-form-edit',
    templateUrl: './fi-form-edit.component.html',
    styleUrls: ['./fi-form-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiFormEditComponent implements OnInit {
    @Input() form: IFormEdit;
    @ViewChild(FiFormEditSettingsComponent, { static: false }) formEditSettingsComponent: FiFormEditSettingsComponent;
    @ViewChild(FiFormEditFormComponent, { static: false }) formEditFormComponent: FiFormEditFormComponent;
    @ViewChild(FiFormEditLogicComponent, { static: false }) formEditLogicComponent: FiFormEditLogicComponent;

    selectedLanguageId: number;
    defaultLanguageId: number;
    isValidationErrorOnFormSave: boolean = false;
    selectedTabIndex: number = 0;
    private pageTitle: string;
    previewData$ = new BehaviorSubject<IFormPreviewData>(null);
    EditTabs: EditTabsModel;
    isAccessRightsTooltipHidden = true;

    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private contentLanguageSharedService: FiContentLanguageSharedService,
        private formService: FiFormService,
        private formSharedService: FiFormSharedService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private stateService: FiStateService,
        private statisticService: StatisticService,
        private fiLoadingService: LoadingService,
        private detectDevice: DetectDevicesService,
        private snackBar: FiSnackBarService,
        private objectTitleService: ObjectTitleService,
        private pageTitleService: PageTitleService,
        private formHelperService: FiFormHelperService,
    ) {}

    ngOnInit() {
        this.statisticService.Visit(ModuleType.Form, ObjectTypes.Form, this.form.Id);

        this.contentLanguagesService.InitializeContentLanguages(
            this.form,
            cloneDeep({
                Names: this.form.Names,
                Descriptions: this.form.Descriptions,
            }),
        );

        this.defaultLanguageId = this.contentLanguageSharedService.getDefaultContentLanguageId();

        this.pageTitle =
            this.form.Id || this.form.Name
                ? this.objectTitleService.getEditTitle(this.form.Name)
                : this.objectTitleService.getCreateTitle(ObjectTypes.Form);

        this.EditTabs = new EditTabsModel(this.pageTitle, this.appTextService.get('back'));

        this.pageTitleService.setTitleByName(this.form.Name, ObjectTypes.Form);
        setTimeout(() => this.saveChangesWarningService.start(() => this.getChangesModel()));

        if (!!this.form.Id) {
            this.selectedLanguageId = this.contentLanguageSharedService.getContentLanguageIdByContentTranslation(
                this.form.Names,
            );
        }
    }

    private getChangesModel() {
        return {
            form: this.form,
            previewData: this.previewData$.value,
        };
    }

    getTitle() {
        return this.previewData$.value
            ? this.appTextService.get('common.preview') + ' - ' + (this.form.Name || this.pageTitle)
            : this.pageTitle;
    }

    save() {
        /* update condition data
        this.applyConditionIndexes();*/

        this.fiLoadingService.trackPromise(
            this.formService.saveForm(this.form).then(() => {
                this.formEditSettingsComponent.accessRightFilters.OnAccessRightFilterCollectionSaved();
                this.saveChangesWarningService.stop();
                this.stateService.go(FiStateNames.Form.List, { filterType: SideListOptionType.FormsToAnswer });
            }),
        );
    }

    /*private applyConditionIndexes() {
        this.form.Conditions.forEach(condition => {
            const sourceQuestion = this.form.Questions.find(question => question.uid == condition.sourceQuestionUid);
            condition.SourceQuestionIdx = this.form.Questions.indexOf(sourceQuestion);
            condition.TargetQuestionIdx = this.form.Questions.findIndex(question => question.uid == condition.targetQuestionUid);
            condition.ConditionPresetOptionIndexes = condition.presetOptionUids.map(uid => sourceQuestion.PresetOptions.findIndex(presetOption => presetOption.uid == uid));
        });
    }*/

    onLanguageChange($event) {
        this.selectedLanguageId = $event;
    }

    isFormTranslated(): boolean {
        return this.form.Questions.some((question: IFormQuestion) => {
            return question.Names.some((name: IContentLanguageLabelModel) => name.Value);
        });
    }

    setQuestionTranslationsGroup(form: IFormEdit) {
        this.formHelperService.setQuestionTranslationsGroup(form);
    }

    onValidateError(inputsWithErrors: NgModel[]) {
        const invalidQuestionLanguageIds: number[] = inputsWithErrors
            .map((input) => {
                if (input.name && (input.name.includes('question') || input.name.includes('formName'))) {
                    const languageId: number = +input.name.replace(/\D/g, '');
                    return languageId;
                }
                return undefined;
            })
            .filter((languageId) => isDefined(languageId));

        if (invalidQuestionLanguageIds.length && !invalidQuestionLanguageIds.includes(this.selectedLanguageId)) {
            this.selectedLanguageId = invalidQuestionLanguageIds[0];
        }

        this.setMatTabIndexOnValidateError(inputsWithErrors);
        this.isValidationErrorOnFormSave = true;
    }

    private setMatTabIndexOnValidateError(inputsWithErrors: NgModel[]) {
        const valueAccessors = inputsWithErrors.map((ngModel) => ngModel.valueAccessor);
        let errorMessage = this.appTextService.get('common.error_all_mandatory');
        if (
            valueAccessors.indexOf(this.formEditFormComponent) !== -1 ||
            valueAccessors.indexOf(
                this.formEditFormComponent.fiChoiceQuestionComponent?.fiChoiceQuestionValidateComponent,
            ) !== -1
        ) {
            this.showErrorDialog(errorMessage);
            this.selectedTabIndex = 0;
            return;
        }
        if (valueAccessors.indexOf(this.formEditLogicComponent) !== -1) {
            this.showErrorDialog(errorMessage);
            this.selectedTabIndex = 1;
            return;
        }
        if (
            valueAccessors.indexOf(this.formEditSettingsComponent) !== -1 ||
            valueAccessors.indexOf(this.formEditSettingsComponent.accessRightFilters) !== -1
        ) {
            errorMessage = this.formEditSettingsComponent.accessRightFilters.getErrorMessage();
            this.showErrorDialog(errorMessage);
            this.selectedTabIndex = 2;
            return;
        }
    }

    private showErrorDialog(errorMessage: string) {
        this.fiDialogsService.notify({
            messageText: errorMessage,
            headerText: this.appTextService.get('common.warning'),
        });
    }

    openPreview($event) {
        $event.preventDefault();

        /* update condition data
        this.applyConditionIndexes();*/

        this.fiLoadingService
            .trackPromise(this.formSharedService.getFormViewerForPreview(this.form))
            .then((formViewer) => {
                this.stateService.go(
                    this.stateService.current.name,
                    {
                        preview: true,
                    },
                    {
                        notify: false,
                    },
                );
                this.previewData$.next({
                    formViewer: formViewer,
                    selectedLanguageId: this.contentLanguageSharedService.getDefaultContentLanguageId(),
                    isMobileView: this.detectDevice.isMobileSmall(),
                    languageList: this.contentLanguageSharedService.getContentLanguages(),
                    onSave: () => {
                        this.snackBar.showSnackbar({
                            textMessage: this.appTextService.get('form.completed'),
                            buttonText: this.appTextService.get('common.dismiss'),
                        });
                        window.history.back();
                    },
                });

                this.stateService.setBackButtonHandler(() => {
                    this.previewData$.next(null);
                });
            });
    }

    onSelectedIndexChanged($event: number) {
        this.isAccessRightsTooltipHidden = $event !== 2;
    }
}
